import React, { Component } from 'react';
import { Form, Card, Button, Col, Jumbotron, OverlayTrigger, Tooltip, Nav, Table, Alert } from 'react-bootstrap';
import Menu from '../menu'
// import errores from '../../middleware/errordb'
import back from '../../back.svg';
import config from '../../config';
import Mensajes from '../subcomponent/mensajes';
import ModalConfirm from '../subcomponent/modalConfirm';
import funciones from '../../middleware/funciones';
import SearchEmployee from '../subcomponent/searchEmployee'
import moment from 'moment';
import { Fragment } from 'react';

class FormularioParametros extends Component {
    constructor(props) {
        super(props);
        //const usuarioMofificar = this.props
        const currentCompany = sessionStorage.getItem('company');
        const currentUserType = sessionStorage.getItem('tipo');
        const today = new Date();
        const dd = String(today.getDate()).padStart(2, '0');
        const mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!mm
        const yyyy = today.getFullYear();
        const fecha = yyyy + "-" + mm + "-" + dd;
        this.state = {
            titulo: "Crear Parametros",
            mostrarMensaje: false,
            msg: 0,
            comp: "",
            tipo: currentUserType,
            id: "",
            id_parametro: "",
            fecha_inicial: fecha,
            fecha_final: fecha,
            fecha_inicial_v: fecha,
            fecha_final_v: fecha,
            fecha_inicial_l: fecha,
            fecha_final_l: fecha,
            fecha_inicial_l2: fecha,
            fecha_final_l2: fecha,
            fecha_inicial_l3: fecha,
            fecha_final_l3: fecha,
            fecha_inicial_I: fecha,
            fecha_final_I: fecha,
            SUELDO_EMPLEADO: "",
            VALOR_CESANTIAS: 0,
            VALOR_PENSION: 0,
            VALOR_SALUD: 0,
            PORCENTAJE_PENSION: 0,
            PORCENTAJE_SALUD: 0,
            PORCENTAJE_CESANTIAS: 0,
            SALARIO_INTEGRAL: 0,
            PAY_CESANTIAS: false,
            //CABECERA
            ID_EMPRESA: currentCompany,
            ID_EMPLEADO: "",
            NOMBRE_EMPLEADO: "",
            DOCUMENTO_EMPLEADO: "",
            DIRECCION_EMPLEADO: "",
            CIUDAD_EMPLEADO: "",
            BANCO_EMPLEADO: "",
            TIPO_DOCUMENTO_NOMINA: "NE",
            TIPO_CUENTA_EMPLEADO: "",
            NUMERO_CUENTA_EMPLEADO: "",
            NUMERO_DOCUMENTO_NOMINA: 0,
            INICIO_PERIODO: "",
            FIN_PERIODO: "",
            DEVENGADOS_TOTAL: "",
            DEDUCCIONES_TOTAL: "",
            COMPROBANTE_TOTAL: "",
            fecha_hoy: fecha,
            DOCUMENTO_RELACION: "",
            AJUSTE: false,
            //DETALLE
            UNIDAD_TIEMPO: "HORAS",
            HRE_DIU: "DIURNAS",
            HRE_NOC: "NOCTURNAS",
            RECARGO_NOC: "RECARGO NOCTURNO",
            DOMIN_FEST: "DOMINICALES Y FESTIVAS",
            REC_DOMIN_FEST: "RECARGO DOMINICALES Y FESTIVAS",
            NOC_DOMIN_FEST: "NOCTURNO DOMINICALES Y FESTIVAS",
            REC_NOC_DOMIN_FEST: "RECARGO NOCTURNO DOMINICALES Y FESTIVAS",
            //NUMERO_DOCUMENTO_NOMINA: 0,
            HORAS_REC_NOC_DOMIN_FEST: "",
            VALOR_TOTAL_LINEA: "",
            VALOR_OTRO_DEVENGADO: 0,
            HORAS_NOC_DOMIN_FEST: "",
            VALOR_NOC_DOMIN_FEST: "",
            HORAS_REC_DOMIN_FEST: "",
            VALOR_REC_DOMIN_FEST: "",
            HORAS_DOMIN_FEST: "",
            VALOR_DOMION_FEST: "",
            HORAS_REC_NOC: "",
            VALOR_REC_NOC: "",
            DESCRIPCION_DEVENGADO: "",
            DES_OTRO_DEVEN: "",
            DES_OTRA_DEDUC: "",
            TIPO_DEVENGADO: "",
            UNIDA_TIEMPO: "",
            VALOR_HORA: 0,
            VALOR_NOCT: "",
            TOTAL_DIAS_NOMINA: "",
            PORCENTAJE: 0,
            TOTAL_TIEMPO_DEVENGADO: 0,
            TOTAL_TIEMPO_DEVENGADO_V: 0,
            TOTAL_TIEMPO_DEVENGADO_L: 0,
            TOTAL_TIEMPO_DEVENGADO_L2: 0,
            TOTAL_TIEMPO_DEVENGADO_L3: 0,
            TOTAL_TIEMPO_DEVENGADO_I: 0,
            VALOR_TOTAL_DEVENGADO: "",
            TOTAL_PRIMA: "0",
            TOTAL_HRED: "",
            TOTAL_HREN: "",
            VALOR: "",
            VALOR_SMLV: "",
            TOTAL_TIEMPO_DEVEN: "",
            PERIODO_INICIO: "",
            PERIODO_FIN: "",
            TIPO_INCAPACIDAD: "",
            LIBRANZA: 0,
            DESCRIPCION_LIBRANZA: "",
            ANTICIPO: 0,
            DIRECCION_EMPRESA: "",
            TELEFONO_EMPRESA: "",
            OTRAS_DEDUCCIONES: 0,
            AUX_TRANSPORTE: 0,
            USAR_NORMA_LEY_EMPLEADO: 1,
            numeroDocNomina: 0,
            showAlert: false,
            empleados: [],
            parametros: [],
            documentos: [],
            detalle_nomina: [],
            tipo_usuario: "",
            buttonmsg: "",
            mensaje: "",
            checkT: true,
            auxTrans: false,
            horaExtr: false,
            vacaciones: false,
            prima: false,
            incap: false,
            licen: false,
            otros: false,
            sindicato: false,
            sanciones: false,
            libra: false,
            pagter: false,
            anti: false,
            otrade: false,
            variant: '',
            alertmessage: '',
            show_cesantias:false,
            show_int_cesantias: false,
            TOTAL_CESANTIAS: 0,
            TOTAL_INT_CESANTIAS: 0,
            TOTAL_LINEA_DEVENGADO_V:0
        }
    }

    componentDidMount() {
        this.initNomina();
    }

    initNomina = () => {
        const datasend = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'empresa': this.state.ID_EMPRESA,
            }
        }
        fetch(config.servBackEnd + '/payroll/' + this.state.ID_EMPRESA, datasend).then(response => response.json())
            .then(data => {
                if (data.ok) {
                    const cData = data.data;
                    const empleados = cData[0];
                    const parametros = cData[1];
                    const empresa = cData[2];
                    const documentos = cData[3];
                    const TIPO_DOCUMENTO_NOMINA = (cData[4][0]) ? cData[4][0]["PREFIJO"] : "NE";
                    this.setState({
                        empleados,
                        parametros,
                        documentos,
                        TIPO_DOCUMENTO_NOMINA,
                        VALOR_SMLV: parametros[0]["VALOR_SMLV"],
                        DIRECCION_EMPRESA: empresa[0]["DIRECCION"],
                        TELEFONO_EMPRESA: empresa[0]["TELEFONO"],
                        AUX_TRANSPORTE: parametros[0]["AUX_TRANSPORTE"],
                        PORCENTAJE_PENSION: parametros[0]["PORCENTAJE_PENSION"],
                        PORCENTAJE_SALUD: parametros[0]["PORCENTAJE_SALUD"],
                        PORCENTAJE_CESANTIAS: parametros[0]["PORCENTAJE_CESANTIAS"]
                    });

                } else {                 
                    // console.log("La información no está ok");
                }
            });
    }

    selectEmployee = (employee) => {
        // console.log(this.state.TOTAL_TIEMPO_DEVENGADO);
        const parametros = this.state.parametros[0]
        const value = employee.ID_EMPLEADO;
        if (value) {
            this.setState({
                DOCUMENTO_EMPLEADO: employee.DOCUMENTO_EMPLEADO,
                NOMBRE_EMPLEADO: employee.NOMBRE_COMPLETO,
                DIRECCION_EMPLEADO: employee.DIRECCION_EMPLEADO,
                CIUDAD_EMPLEADO: employee.CODIGO_MUNICIPIO_EMPLEADO,
                BANCO_EMPLEADO: employee.BANCO,
                TIPO_CUENTA_EMPLEADO: employee.TIPO_CUENTA,
                NUMERO_CUENTA_EMPLEADO: employee.NUMERO_CUENTA,
                ID_EMPLEADO: employee.ID_EMPLEADO,
                SUELDO_EMPLEADO: employee.SUELDO_EMPLEADO,
                VALOR_PENSION: (employee.SALARIO_INTEGRAL==="1") ? 0 : (employee.SUELDO_EMPLEADO/30) * this.state.TOTAL_TIEMPO_DEVENGADO * (parametros.PORCENTAJE_PENSION/100),
                VALOR_SALUD: (employee.SALARIO_INTEGRAL==="1") ? 0 : (employee.SUELDO_EMPLEADO /30 )* this.state.TOTAL_TIEMPO_DEVENGADO * (parametros.PORCENTAJE_SALUD/100) ,
                //VALOR_CESANTIAS: employee.VALOR_CESANTIAS,
                SALARIO_INTEGRAL: employee.SALARIO_INTEGRAL,
                VALOR_HORA: employee.SUELDO_EMPLEADO / 240,
                AUXILIO_TRANSPORTE_EMPLEADO: employee.AUXILIO_TRANSPORTE,
                USAR_NORMA_LEY_EMPLEADO: employee.USAR_NORMA_LEY
            })
        }
        

    }

    handleSubmit = (event) => {
        event.preventDefault();
        this.setState({ show: true });
    }

    handleClose = () => {
        this.setState({ show: false });
    };

    constructorDetail = () => {
        const dataState = this.state
        // const datosDetail = [
        //     "TOTAL_HRED",
        //     "TOTAL_HREN",
        //     "HORAS_REC_NOC",
        //     "HORAS_DOMIN_FEST",
        //     "HORAS_REC_DOMIN_FEST",
        //     "HORAS_NOC_DOMIN_FEST",
        //     "HORAS_REC_NOC_DOMIN_FEST",
        //     "TOTAL_TIEMPO_DEVENGADO_V",
        //     "TOTAL_TIEMPO_DEVENGADO_L",
        //     "TOTAL_TIEMPO_DEVENGADO_L2",
        //     "TOTAL_TIEMPO_DEVENGADO_L3",
        //     "VALOR_OTRO_DEVENGADO",
        //     "TOTAL_PRIMA",
        //     "TOTAL_TIEMPO_DEVENGADO_I",
        //     "ANTICIPO",
        //     "OTRAS_DEDUCCIONES",
        //     "LIBRANZA"
        // ];
        const factor = {
            "TOTAL_HRED": 1.25,
            "TOTAL_HREN": 1.75,
            "HORAS_REC_NOC": 1.35,
            "HORAS_DOMIN_FEST": 2,
            "HORAS_REC_DOMIN_FEST": 1.75,
            "HORAS_NOC_DOMIN_FEST": 2.5,
            "HORAS_REC_NOC_DOMIN_FEST": 2.1
        }
        const tipo = {
            "TOTAL_HRED": 1,
            "TOTAL_HREN": 1,
            "HORAS_REC_NOC": 1,
            "HORAS_DOMIN_FEST": 1,
            "HORAS_REC_DOMIN_FEST": 1,
            "HORAS_NOC_DOMIN_FEST": 1,
            "HORAS_REC_NOC_DOMIN_FEST": 1,
            "TOTAL_TIEMPO_DEVENGADO_V": 1,
            "TOTAL_TIEMPO_DEVENGADO_L": 1,
            "TOTAL_TIEMPO_DEVENGADO_L2": 1,
            "TOTAL_TIEMPO_DEVENGADO_L3": 1,
            "VALOR_OTRO_DEVENGADO": 1,
            "TOTAL_PRIMA": 1,
            "TOTAL_TIEMPO_DEVENGADO_I": 1,
            "ANTICIPO": 2,
            "OTRAS_DEDUCCIONES": 2

        }
        let detalle = [];
        detalle.push({
            //push de salario, cesantias...
            ID_EMPRESA: this.state.ID_EMPRESA,
            TIPO_DOCUMENTO_NOMINA: this.state.TIPO_DOCUMENTO_NOMINA,
            ID_EMPLEADO: this.state.ID_EMPLEADO,
            NOMBRE_EMPLEADO: this.state.NOMBRE_EMPLEADO,
            DOCUMENTO_EMPLEADO: this.state.DOCUMENTO_EMPLEADO,
            VALOR: this.state.SUELDO_EMPLEADO /30 * this.state.TOTAL_TIEMPO_DEVENGADO,
            DESCRIPCION_DEVEN_O_DEDUC: "SUELDO EMPLEADO",
            TIPO: 1,
            VALOR_TOTAL_LINEA: this.state.SUELDO_EMPLEADO /30 * this.state.TOTAL_TIEMPO_DEVENGADO,
            CODIGO_MOVIMIENTO: "18"
        });
        // detalle.push({
        //     //push de salario, cesantias...
        //     ID_EMPRESA: this.state.ID_EMPRESA,
        //     TIPO_DOCUMENTO_NOMINA: this.state.TIPO_DOCUMENTO_NOMINA,
        //     ID_EMPLEADO: this.state.ID_EMPLEADO,
        //     NOMBRE_EMPLEADO: this.state.NOMBRE_EMPLEADO,
        //     DOCUMENTO_EMPLEADO: this.state.DOCUMENTO_EMPLEADO,
        //     VALOR: this.state.VALOR_CESANTIAS,
        //     DESCRIPCION_DEVEN_O_DEDUC: "CESANTIAS",
        //     TIPO: 2,
        //     VALOR_TOTAL_LINEA: this.state.VALOR_CESANTIAS,
        //     CODIGO_MOVIMIENTO: "19",
        //     PORCENTAJE: this.state.PORCENTAJE_CESANTIAS
        // });
        detalle.push({
            //push de salario, cesantias...
            ID_EMPRESA: this.state.ID_EMPRESA,
            TIPO_DOCUMENTO_NOMINA: this.state.TIPO_DOCUMENTO_NOMINA,
            ID_EMPLEADO: this.state.ID_EMPLEADO,
            NOMBRE_EMPLEADO: this.state.NOMBRE_EMPLEADO,
            DOCUMENTO_EMPLEADO: this.state.DOCUMENTO_EMPLEADO,
            VALOR: this.state.VALOR_SALUD,
            DESCRIPCION_DEVEN_O_DEDUC: "EPS",
            TIPO: 2,
            VALOR_TOTAL_LINEA: this.state.VALOR_SALUD,
            CODIGO_MOVIMIENTO: "20",
            PORCENTAJE: this.state.PORCENTAJE_SALUD
        });
        detalle.push({
            //push de salario, cesantias...
            ID_EMPRESA: this.state.ID_EMPRESA,
            TIPO_DOCUMENTO_NOMINA: this.state.TIPO_DOCUMENTO_NOMINA,
            ID_EMPLEADO: this.state.ID_EMPLEADO,
            NOMBRE_EMPLEADO: this.state.NOMBRE_EMPLEADO,
            DOCUMENTO_EMPLEADO: this.state.DOCUMENTO_EMPLEADO,
            VALOR: this.state.VALOR_PENSION,
            DESCRIPCION_DEVEN_O_DEDUC: "PENSION",
            TIPO: 2,
            VALOR_TOTAL_LINEA: this.state.VALOR_PENSION,
            CODIGO_MOVIMIENTO: "21",
            PORCENTAJE: this.state.PORCENTAJE_PENSION
        });
        const valor_limite = this.state.VALOR_SMLV * 2;
        let validAuxTrans = false;

        // console.log(this.state.USAR_NORMA_LEY_EMPLEADO)
        // console.log(this.state.AUXILIO_TRANSPORTE_EMPLEADO)

        if(this.state.USAR_NORMA_LEY_EMPLEADO && this.state.SUELDO_EMPLEADO <= valor_limite) validAuxTrans = true;
        if(!this.state.USAR_NORMA_LEY_EMPLEADO && this.state.AUXILIO_TRANSPORTE_EMPLEADO) validAuxTrans = true;
        if(!this.state.USAR_NORMA_LEY_EMPLEADO && !this.state.AUXILIO_TRANSPORTE_EMPLEADO) validAuxTrans = false;
        // console.log(validAuxTrans)
        if (validAuxTrans) {
            detalle.push({
                ID_EMPRESA: this.state.ID_EMPRESA,
                TIPO_DOCUMENTO_NOMINA: this.state.TIPO_DOCUMENTO_NOMINA,
                ID_EMPLEADO: this.state.ID_EMPLEADO,
                NOMBRE_EMPLEADO: this.state.NOMBRE_EMPLEADO,
                DOCUMENTO_EMPLEADO: this.state.DOCUMENTO_EMPLEADO,
                VALOR: this.state.AUX_TRANSPORTE/30 * this.state.TOTAL_TIEMPO_DEVENGADO,
                DESCRIPCION_DEVEN_O_DEDUC: "AUX TRANSPORTE",
                TIPO: 1,
                VALOR_TOTAL_LINEA: this.state.AUX_TRANSPORTE/30 * this.state.TOTAL_TIEMPO_DEVENGADO,
                CODIGO_MOVIMIENTO: "22"
            });
        }
        let index = 0;
        do {
            const found = Object.keys(dataState)[index];
            if (found === "TOTAL_HRED" || found === "TOTAL_HREN" || found === "HORAS_REC_NOC" || found === "HORAS_DOMIN_FEST" || found === "HORAS_REC_DOMIN_FEST" || found === "HORAS_NOC_DOMIN_FEST" || found === "HORAS_REC_NOC_DOMIN_FEST") {
                const valor_hora = ((this.state.SUELDO_EMPLEADO / 240) * factor[Object.keys(dataState)[index]]).toFixed(2);
                const total_linea = dataState[Object.keys(dataState)[index]] * valor_hora
                if (total_linea > 0) {
                    if (found === "TOTAL_HRED") {
                        detalle.push(
                            {
                                ID_EMPRESA: this.state.ID_EMPRESA,
                                TIPO_DOCUMENTO_NOMINA: this.state.TIPO_DOCUMENTO_NOMINA,
                                ID_EMPLEADO: this.state.ID_EMPLEADO,
                                NOMBRE_EMPLEADO: this.state.NOMBRE_EMPLEADO,
                                DOCUMENTO_EMPLEADO: this.state.DOCUMENTO_EMPLEADO,
                                VALOR: valor_hora,
                                DESCRIPCION_DEVEN_O_DEDUC: Object.keys(dataState)[index],
                                TIPO: tipo[Object.keys(dataState)[index]],
                                UNIDAD_TIEMPO: 'HORA',
                                PORCENTAJE: 25,
                                VALOR_TOTAL_LINEA: total_linea,
                                TOTAL_TIEMPO_DEVEN: dataState[Object.keys(dataState)[index]],
                                CODIGO_MOVIMIENTO: "01"
                            }
                        );
                    } else if (found === "TOTAL_HREN") {

                        detalle.push(
                            {
                                ID_EMPRESA: this.state.ID_EMPRESA,
                                TIPO_DOCUMENTO_NOMINA: this.state.TIPO_DOCUMENTO_NOMINA,
                                ID_EMPLEADO: this.state.ID_EMPLEADO,
                                NOMBRE_EMPLEADO: this.state.NOMBRE_EMPLEADO,
                                DOCUMENTO_EMPLEADO: this.state.DOCUMENTO_EMPLEADO,
                                VALOR: valor_hora,
                                DESCRIPCION_DEVEN_O_DEDUC: Object.keys(dataState)[index],
                                TIPO: tipo[Object.keys(dataState)[index]],
                                UNIDAD_TIEMPO: 'HORA',
                                PORCENTAJE: 75,
                                VALOR_TOTAL_LINEA: total_linea,
                                TOTAL_TIEMPO_DEVEN: dataState[Object.keys(dataState)[index]],
                                CODIGO_MOVIMIENTO: "02"
                            }
                        );
                    } else if (found === "HORAS_REC_NOC") {
                        detalle.push(
                            {
                                ID_EMPRESA: this.state.ID_EMPRESA,
                                TIPO_DOCUMENTO_NOMINA: this.state.TIPO_DOCUMENTO_NOMINA,
                                ID_EMPLEADO: this.state.ID_EMPLEADO,
                                NOMBRE_EMPLEADO: this.state.NOMBRE_EMPLEADO,
                                DOCUMENTO_EMPLEADO: this.state.DOCUMENTO_EMPLEADO,
                                VALOR: valor_hora,
                                DESCRIPCION_DEVEN_O_DEDUC: Object.keys(dataState)[index],
                                TIPO: tipo[Object.keys(dataState)[index]],
                                UNIDAD_TIEMPO: 'HORA',
                                PORCENTAJE: 35,
                                VALOR_TOTAL_LINEA: total_linea,
                                TOTAL_TIEMPO_DEVEN: dataState[Object.keys(dataState)[index]],
                                CODIGO_MOVIMIENTO: "03"
                            }
                        );
                    } else if (found === "HORAS_DOMIN_FEST") {
                        detalle.push(
                            {
                                ID_EMPRESA: this.state.ID_EMPRESA,
                                TIPO_DOCUMENTO_NOMINA: this.state.TIPO_DOCUMENTO_NOMINA,
                                ID_EMPLEADO: this.state.ID_EMPLEADO,
                                NOMBRE_EMPLEADO: this.state.NOMBRE_EMPLEADO,
                                DOCUMENTO_EMPLEADO: this.state.DOCUMENTO_EMPLEADO,
                                VALOR: valor_hora,
                                DESCRIPCION_DEVEN_O_DEDUC: Object.keys(dataState)[index],
                                TIPO: tipo[Object.keys(dataState)[index]],
                                UNIDAD_TIEMPO: 'HORA',
                                PORCENTAJE: 100,
                                VALOR_TOTAL_LINEA: total_linea,
                                TOTAL_TIEMPO_DEVEN: dataState[Object.keys(dataState)[index]],
                                CODIGO_MOVIMIENTO: "04"
                            }
                        );
                    } else if (found === "HORAS_REC_DOMIN_FEST") {
                        detalle.push(
                            {
                                ID_EMPRESA: this.state.ID_EMPRESA,
                                TIPO_DOCUMENTO_NOMINA: this.state.TIPO_DOCUMENTO_NOMINA,
                                ID_EMPLEADO: this.state.ID_EMPLEADO,
                                NOMBRE_EMPLEADO: this.state.NOMBRE_EMPLEADO,
                                DOCUMENTO_EMPLEADO: this.state.DOCUMENTO_EMPLEADO,
                                VALOR: valor_hora,
                                DESCRIPCION_DEVEN_O_DEDUC: Object.keys(dataState)[index],
                                TIPO: tipo[Object.keys(dataState)[index]],
                                UNIDAD_TIEMPO: 'HORA',
                                PORCENTAJE: 75,
                                VALOR_TOTAL_LINEA: total_linea,
                                TOTAL_TIEMPO_DEVEN: dataState[Object.keys(dataState)[index]],
                                CODIGO_MOVIMIENTO: "05"
                            }
                        );
                    } else if (found === "HORAS_NOC_DOMIN_FEST") {
                        detalle.push(
                            {
                                ID_EMPRESA: this.state.ID_EMPRESA,
                                TIPO_DOCUMENTO_NOMINA: this.state.TIPO_DOCUMENTO_NOMINA,
                                ID_EMPLEADO: this.state.ID_EMPLEADO,
                                NOMBRE_EMPLEADO: this.state.NOMBRE_EMPLEADO,
                                DOCUMENTO_EMPLEADO: this.state.DOCUMENTO_EMPLEADO,
                                VALOR: valor_hora,
                                DESCRIPCION_DEVEN_O_DEDUC: Object.keys(dataState)[index],
                                TIPO: tipo[Object.keys(dataState)[index]],
                                UNIDAD_TIEMPO: 'HORA',
                                PORCENTAJE: 150,
                                VALOR_TOTAL_LINEA: total_linea,
                                TOTAL_TIEMPO_DEVEN: dataState[Object.keys(dataState)[index]],
                                CODIGO_MOVIMIENTO: "06"
                            }
                        );
                    } else if (found === "HORAS_REC_NOC_DOMIN_FEST") {
                        detalle.push(
                            {
                                ID_EMPRESA: this.state.ID_EMPRESA,
                                TIPO_DOCUMENTO_NOMINA: this.state.TIPO_DOCUMENTO_NOMINA,
                                ID_EMPLEADO: this.state.ID_EMPLEADO,
                                NOMBRE_EMPLEADO: this.state.NOMBRE_EMPLEADO,
                                DOCUMENTO_EMPLEADO: this.state.DOCUMENTO_EMPLEADO,
                                VALOR: valor_hora,
                                DESCRIPCION_DEVEN_O_DEDUC: Object.keys(dataState)[index],
                                TIPO: tipo[Object.keys(dataState)[index]],
                                UNIDAD_TIEMPO: 'HORA',
                                PORCENTAJE: 110,
                                VALOR_TOTAL_LINEA: total_linea,
                                TOTAL_TIEMPO_DEVEN: dataState[Object.keys(dataState)[index]],
                                CODIGO_MOVIMIENTO: "07"
                            }
                        );
                    }

                }
            } else if (found === "TOTAL_TIEMPO_DEVENGADO_V") {
                const total_linea = this.state.TOTAL_LINEA_DEVENGADO_V;
                const valor_dia_vacaciones = ( this.state.TOTAL_LINEA_DEVENGADO_V / this.state.TOTAL_TIEMPO_DEVENGADO_V).toFixed(2);
                if (total_linea > 0) {
                    detalle.push(
                        {
                            ID_EMPRESA: this.state.ID_EMPRESA,
                            TIPO_DOCUMENTO_NOMINA: this.state.TIPO_DOCUMENTO_NOMINA,
                            ID_EMPLEADO: this.state.ID_EMPLEADO,
                            NOMBRE_EMPLEADO: this.state.NOMBRE_EMPLEADO,
                            DOCUMENTO_EMPLEADO: this.state.DOCUMENTO_EMPLEADO,
                            VALOR: valor_dia_vacaciones,
                            DESCRIPCION_DEVEN_O_DEDUC: 'VACACIONES',
                            PERIODO_INICIO: this.state.fecha_inicial_v,
                            PERIODO_FIN: this.state.fecha_final_v,
                            TIPO: tipo[Object.keys(dataState)[index]],
                            UNIDAD_TIEMPO: 'DIAS',
                            VALOR_TOTAL_LINEA: total_linea,
                            TOTAL_TIEMPO_DEVEN: dataState[Object.keys(dataState)[index]],
                            CODIGO_MOVIMIENTO: "08"
                        }
                    );
                }

            } else if (found === "TOTAL_TIEMPO_DEVENGADO_L" || found === "TOTAL_TIEMPO_DEVENGADO_L2") {
                const valor_dia_licencia = (this.state.SUELDO_EMPLEADO / 30).toFixed(2);
                const total_linea = dataState[Object.keys(dataState)[index]] * valor_dia_licencia
                if (total_linea > 0) {
                    if (found === "TOTAL_TIEMPO_DEVENGADO_L") {
                        detalle.push(
                            {
                                ID_EMPRESA: this.state.ID_EMPRESA,
                                TIPO_DOCUMENTO_NOMINA: this.state.TIPO_DOCUMENTO_NOMINA,
                                ID_EMPLEADO: this.state.ID_EMPLEADO,
                                NOMBRE_EMPLEADO: this.state.NOMBRE_EMPLEADO,
                                DOCUMENTO_EMPLEADO: this.state.DOCUMENTO_EMPLEADO,
                                VALOR: valor_dia_licencia,
                                DESCRIPCION_DEVEN_O_DEDUC: Object.keys(dataState)[index],
                                PERIODO_INICIO: this.state.fecha_inicial_l,
                                PERIODO_FIN: this.state.fecha_final_l,
                                TIPO: tipo[Object.keys(dataState)[index]],
                                UNIDAD_TIEMPO: 'DIAS',
                                VALOR_TOTAL_LINEA: total_linea,
                                TOTAL_TIEMPO_DEVEN: dataState[Object.keys(dataState)[index]],
                                CODIGO_MOVIMIENTO: "09"
                            }
                        );
                    } else if (found === "TOTAL_TIEMPO_DEVENGADO_L2") {
                        detalle.push(
                            {
                                ID_EMPRESA: this.state.ID_EMPRESA,
                                TIPO_DOCUMENTO_NOMINA: this.state.TIPO_DOCUMENTO_NOMINA,
                                ID_EMPLEADO: this.state.ID_EMPLEADO,
                                NOMBRE_EMPLEADO: this.state.NOMBRE_EMPLEADO,
                                DOCUMENTO_EMPLEADO: this.state.DOCUMENTO_EMPLEADO,
                                VALOR: valor_dia_licencia,
                                DESCRIPCION_DEVEN_O_DEDUC: Object.keys(dataState)[index],
                                PERIODO_INICIO: this.state.fecha_inicial_l,
                                PERIODO_FIN: this.state.fecha_final_l,
                                TIPO: tipo[Object.keys(dataState)[index]],
                                UNIDAD_TIEMPO: 'DIAS',
                                VALOR_TOTAL_LINEA: total_linea,
                                TOTAL_TIEMPO_DEVEN: dataState[Object.keys(dataState)[index]],
                                CODIGO_MOVIMIENTO: "10"
                            }
                        );
                    }
                }

            } else if (found === "TOTAL_TIEMPO_DEVENGADO_L3") {
                if (this.state.TOTAL_TIEMPO_DEVENGADO_L3 > 0) {
                    detalle.push(
                        {
                            ID_EMPRESA: this.state.ID_EMPRESA,
                            TIPO_DOCUMENTO_NOMINA: this.state.TIPO_DOCUMENTO_NOMINA,
                            ID_EMPLEADO: this.state.ID_EMPLEADO,
                            NOMBRE_EMPLEADO: this.state.NOMBRE_EMPLEADO,
                            DOCUMENTO_EMPLEADO: this.state.DOCUMENTO_EMPLEADO,
                            VALOR: 0,
                            DESCRIPCION_DEVEN_O_DEDUC: Object.keys(dataState)[index],
                            PERIODO_INICIO: this.state.fecha_inicial_l3,
                            PERIODO_FIN: this.state.fecha_final_l3,
                            TIPO: tipo[Object.keys(dataState)[index]],
                            UNIDAD_TIEMPO: 'DIAS',
                            VALOR_TOTAL_LINEA: 0,
                            TOTAL_TIEMPO_DEVEN: dataState[Object.keys(dataState)[index]],
                            CODIGO_MOVIMIENTO: "11"
                        }
                    );
                }

            } else if (found === "VALOR_OTRO_DEVENGADO") {
                const total_linea = this.state.VALOR_OTRO_DEVENGADO;
                if (total_linea > 0) {
                    detalle.push(
                        {
                            ID_EMPRESA: this.state.ID_EMPRESA,
                            TIPO_DOCUMENTO_NOMINA: this.state.TIPO_DOCUMENTO_NOMINA,
                            ID_EMPLEADO: this.state.ID_EMPLEADO,
                            NOMBRE_EMPLEADO: this.state.NOMBRE_EMPLEADO,
                            DOCUMENTO_EMPLEADO: this.state.DOCUMENTO_EMPLEADO,
                            VALOR: this.state.VALOR_OTRO_DEVENGADO,
                            DESCRIPCION_DEVEN_O_DEDUC: Object.keys(dataState)[index],
                            TIPO: tipo[Object.keys(dataState)[index]],
                            VALOR_TOTAL_LINEA: this.state.VALOR_OTRO_DEVENGADO,
                            CODIGO_MOVIMIENTO: "12",
                            DES_OTRO_DEVEN: this.state.DES_OTRO_DEVEN
                        }
                    );
                }

            } else if (found === "TOTAL_PRIMA") {
                //const valor_dia_prima = (((this.state.TOTAL_PRIMA / 180) * (this.state.SUELDO_EMPLEADO / 2)) / 180).toFixed(2);
                const total_linea = this.state.TOTAL_PRIMA
                if (total_linea > 0) {
                    detalle.push(
                        {
                            ID_EMPRESA: this.state.ID_EMPRESA,
                            TIPO_DOCUMENTO_NOMINA: this.state.TIPO_DOCUMENTO_NOMINA,
                            ID_EMPLEADO: this.state.ID_EMPLEADO,
                            NOMBRE_EMPLEADO: this.state.NOMBRE_EMPLEADO,
                            DOCUMENTO_EMPLEADO: this.state.DOCUMENTO_EMPLEADO,
                            VALOR: total_linea,
                            DESCRIPCION_DEVEN_O_DEDUC: "PRIMA",
                            TIPO: tipo[Object.keys(dataState)[index]],
                            UNIDAD_TIEMPO: 'DIAS',
                            VALOR_TOTAL_LINEA: total_linea,
                            TOTAL_TIEMPO_DEVEN: dataState[Object.keys(dataState)[index]],
                            CODIGO_MOVIMIENTO: "13"
                        }
                    );
                }
            }else if (found === "TOTAL_CESANTIAS") {
                //const valor_dia_prima = (((this.state.TOTAL_PRIMA / 180) * (this.state.SUELDO_EMPLEADO / 2)) / 180).toFixed(2);
                const total_linea = this.state.TOTAL_CESANTIAS
                if (total_linea > 0) {
                    detalle.push(
                        {
                            ID_EMPRESA: this.state.ID_EMPRESA,
                            TIPO_DOCUMENTO_NOMINA: this.state.TIPO_DOCUMENTO_NOMINA,
                            ID_EMPLEADO: this.state.ID_EMPLEADO,
                            NOMBRE_EMPLEADO: this.state.NOMBRE_EMPLEADO,
                            DOCUMENTO_EMPLEADO: this.state.DOCUMENTO_EMPLEADO,
                            VALOR: total_linea,
                            DESCRIPCION_DEVEN_O_DEDUC: "CESANTIAS",
                            TIPO: tipo[Object.keys(dataState)[index]],
                            UNIDAD_TIEMPO: 'DIAS',
                            VALOR_TOTAL_LINEA: total_linea,
                            TOTAL_TIEMPO_DEVEN: dataState[Object.keys(dataState)[index]],
                            CODIGO_MOVIMIENTO: "19"
                        }
                    );
                }
            }else if (found === "TOTAL_INT_CESANTIAS") {
                //const valor_dia_prima = (((this.state.TOTAL_PRIMA / 180) * (this.state.SUELDO_EMPLEADO / 2)) / 180).toFixed(2);
                const total_linea = this.state.TOTAL_INT_CESANTIAS
                if (total_linea > 0) {
                    detalle.push(
                        {
                            ID_EMPRESA: this.state.ID_EMPRESA,
                            TIPO_DOCUMENTO_NOMINA: this.state.TIPO_DOCUMENTO_NOMINA,
                            ID_EMPLEADO: this.state.ID_EMPLEADO,
                            NOMBRE_EMPLEADO: this.state.NOMBRE_EMPLEADO,
                            DOCUMENTO_EMPLEADO: this.state.DOCUMENTO_EMPLEADO,
                            VALOR: total_linea,
                            DESCRIPCION_DEVEN_O_DEDUC: "INTERESES CESANTIAS",
                            TIPO: tipo[Object.keys(dataState)[index]],
                            UNIDAD_TIEMPO: 'DIAS',
                            VALOR_TOTAL_LINEA: total_linea,
                            TOTAL_TIEMPO_DEVEN: dataState[Object.keys(dataState)[index]],
                            CODIGO_MOVIMIENTO: "23"
                        }
                    );
                }
            } else if (found === "TOTAL_TIEMPO_DEVENGADO_I") {
                if (this.state.TIPO_INCAPACIDAD === "1") {
                    const valor_dia_incapacidad = ((this.state.SUELDO_EMPLEADO / 30) * 2).toFixed(2);
                    const total_linea = dataState[Object.keys(dataState)[index]] * valor_dia_incapacidad

                    if (total_linea > 0) {
                        detalle.push(
                            {
                                ID_EMPRESA: this.state.ID_EMPRESA,
                                TIPO_DOCUMENTO_NOMINA: this.state.TIPO_DOCUMENTO_NOMINA,
                                ID_EMPLEADO: this.state.ID_EMPLEADO,
                                NOMBRE_EMPLEADO: this.state.NOMBRE_EMPLEADO,
                                DOCUMENTO_EMPLEADO: this.state.DOCUMENTO_EMPLEADO,
                                VALOR: valor_dia_incapacidad,
                                DESCRIPCION_DEVEN_O_DEDUC: Object.keys(dataState)[index],
                                PERIODO_INICIO: this.state.fecha_inicial_I,
                                PERIODO_FIN: this.state.fecha_final_I,
                                TIPO: tipo[Object.keys(dataState)[index]],
                                TIPO_INCAPACIDAD: this.state.TIPO_INCAPACIDAD,
                                UNIDAD_TIEMPO: 'DIAS',
                                VALOR_TOTAL_LINEA: total_linea,
                                TOTAL_TIEMPO_DEVEN: dataState[Object.keys(dataState)[index]],
                                CODIGO_MOVIMIENTO: "14"
                            }
                        );
                    }


                } else if (this.state.TIPO_INCAPACIDAD === "2") {
                    const valor_dia_incapacidad = ((this.state.SUELDO_EMPLEADO / 30) * 5).toFixed(2);
                    const total_linea = dataState[Object.keys(dataState)[index]] * valor_dia_incapacidad

                    if (total_linea > 0) {
                        detalle.push(
                            {
                                ID_EMPRESA: this.state.ID_EMPRESA,
                                TIPO_DOCUMENTO_NOMINA: this.state.TIPO_DOCUMENTO_NOMINA,
                                ID_EMPLEADO: this.state.ID_EMPLEADO,
                                NOMBRE_EMPLEADO: this.state.NOMBRE_EMPLEADO,
                                DOCUMENTO_EMPLEADO: this.state.DOCUMENTO_EMPLEADO,
                                VALOR: valor_dia_incapacidad,
                                DESCRIPCION_DEVEN_O_DEDUC: Object.keys(dataState)[index],
                                PERIODO_INICIO: this.state.fecha_inicial_I,
                                PERIODO_FIN: this.state.fecha_final_I,
                                TIPO: tipo[Object.keys(dataState)[index]],
                                TIPO_INCAPACIDAD: this.state.TIPO_INCAPACIDAD,
                                UNIDAD_TIEMPO: 'DIAS',
                                VALOR_TOTAL_LINEA: total_linea,
                                TOTAL_TIEMPO_DEVEN: dataState[Object.keys(dataState)[index]],
                                CODIGO_MOVIMIENTO: "14"
                            }
                        );
                    }

                } else if (this.state.TIPO_INCAPACIDAD === "3") {
                    const valor_dia_incapacidad = ((this.state.SUELDO_EMPLEADO / 30) * 7).toFixed(2);
                    const total_linea = dataState[Object.keys(dataState)[index]] * valor_dia_incapacidad

                    if (total_linea > 0) {
                        detalle.push(
                            {
                                ID_EMPRESA: this.state.ID_EMPRESA,
                                TIPO_DOCUMENTO_NOMINA: this.state.TIPO_DOCUMENTO_NOMINA,
                                ID_EMPLEADO: this.state.ID_EMPLEADO,
                                NOMBRE_EMPLEADO: this.state.NOMBRE_EMPLEADO,
                                DOCUMENTO_EMPLEADO: this.state.DOCUMENTO_EMPLEADO,
                                VALOR: valor_dia_incapacidad,
                                DESCRIPCION_DEVEN_O_DEDUC: Object.keys(dataState)[index],
                                PERIODO_INICIO: this.state.fecha_inicial_I,
                                PERIODO_FIN: this.state.fecha_final_I,
                                TIPO: tipo[Object.keys(dataState)[index]],
                                TIPO_INCAPACIDAD: this.state.TIPO_INCAPACIDAD,
                                UNIDAD_TIEMPO: 'DIAS',
                                VALOR_TOTAL_LINEA: total_linea,
                                TOTAL_TIEMPO_DEVEN: dataState[Object.keys(dataState)[index]],
                                CODIGO_MOVIMIENTO: "14"
                            }
                        );
                    }

                }
            } else if (found === "LIBRANZA" && this.state.LIBRANZA > 0) {
                detalle.push({
                    ID_EMPRESA: this.state.ID_EMPRESA,
                    TIPO_DOCUMENTO_NOMINA: this.state.TIPO_DOCUMENTO_NOMINA,
                    ID_EMPLEADO: this.state.ID_EMPLEADO,
                    NOMBRE_EMPLEADO: this.state.NOMBRE_EMPLEADO,
                    DOCUMENTO_EMPLEADO: this.state.DOCUMENTO_EMPLEADO,
                    VALOR: this.state.LIBRANZA,
                    DESCRIPCION_DEVEN_O_DEDUC: this.state.DESCRIPCION_LIBRANZA,
                    TIPO: 2,
                    VALOR_TOTAL_LINEA: this.state.LIBRANZA,
                    CODIGO_MOVIMIENTO: "15"
                })
            } else if (found === "ANTICIPO") {
                if (this.state.ANTICIPO > 0) {
                    detalle.push(
                        {
                            ID_EMPRESA: this.state.ID_EMPRESA,
                            TIPO_DOCUMENTO_NOMINA: this.state.TIPO_DOCUMENTO_NOMINA,
                            ID_EMPLEADO: this.state.ID_EMPLEADO,
                            NOMBRE_EMPLEADO: this.state.NOMBRE_EMPLEADO,
                            DOCUMENTO_EMPLEADO: this.state.DOCUMENTO_EMPLEADO,
                            VALOR: this.state.ANTICIPO,
                            DESCRIPCION_DEVEN_O_DEDUC: Object.keys(dataState)[index],
                            TIPO: tipo[Object.keys(dataState)[index]],
                            VALOR_TOTAL_LINEA: this.state.ANTICIPO,
                            CODIGO_MOVIMIENTO: "16"
                        }
                    );
                }
            } else if (found === "OTRAS_DEDUCCIONES") {
                if (this.state.OTRAS_DEDUCCIONES > 0) {
                    detalle.push(
                        {
                            ID_EMPRESA: this.state.ID_EMPRESA,
                            TIPO_DOCUMENTO_NOMINA: this.state.TIPO_DOCUMENTO_NOMINA,
                            ID_EMPLEADO: this.state.ID_EMPLEADO,
                            NOMBRE_EMPLEADO: this.state.NOMBRE_EMPLEADO,
                            DOCUMENTO_EMPLEADO: this.state.DOCUMENTO_EMPLEADO,
                            VALOR: this.state.OTRAS_DEDUCCIONES,
                            DESCRIPCION_DEVEN_O_DEDUC: Object.keys(dataState)[index],
                            TIPO: tipo[Object.keys(dataState)[index]],
                            VALOR_TOTAL_LINEA: this.state.OTRAS_DEDUCCIONES,
                            CODIGO_MOVIMIENTO: "17",
                            DES_OTRA_DEDUC: this.state.DES_OTRA_DEDUC
                        }
                    );
                }
            }
            index++;
        } while (Object.keys(dataState)[index])



        return detalle;

    }

    calcularTotales = (detalle) => {
        let dedu = 0;
        let deve = 0;
        let totalnomina = 0;

        detalle.forEach(element => {
            if (element.TIPO === 1) {
                if (element.VALOR_TOTAL_LINEA !== 0) {
                    deve += parseFloat(element.VALOR_TOTAL_LINEA);
                }
            } else if (element.TIPO === 2) {
                if (element.VALOR_TOTAL_LINEA !== 0) {
                    dedu += parseFloat(element.VALOR_TOTAL_LINEA);
                }
            }
        });
        totalnomina = (deve - dedu);
        return { DEDUCCIONES_TOTAL: dedu, DEVENGADOS_TOTAL: deve, COMPROBANTE_TOTAL: totalnomina };
    }

    enviarInfo = () => {
        this.setState({ show: false });
        event.preventDefault();
        const detalle = this.constructorDetail();
        const totales = this.calcularTotales(detalle);
        const fecha_periodo = new Date(this.state.fecha_final);
        const perido = fecha_periodo.getFullYear().toString() + (fecha_periodo.getMonth()+1).toString().padStart(2,'0')
        const cabecera = {
            ID_EMPRESA: this.state.ID_EMPRESA,
            TIPO_DOCUMENTO_NOMINA: this.state.TIPO_DOCUMENTO_NOMINA,
            ID_EMPLEADO: this.state.ID_EMPLEADO,
            DIRECCION_EMPRESA: this.state.DIRECCION_EMPRESA,
            TELEFONO_EMPRESA: perido,
            NOMBRE_EMPLEADO: this.state.NOMBRE_EMPLEADO,
            DOCUMENTO_EMPLEADO: this.state.DOCUMENTO_EMPLEADO,
            DIRECCION_EMPLEADO: this.state.DIRECCION_EMPLEADO,
            CIUDAD_EMPLEADO: this.state.CIUDAD_EMPLEADO,
            BANCO_EMPLEADO: this.state.BANCO_EMPLEADO,
            TIPO_CUENTA_EMPLEADO: this.state.TIPO_CUENTA_EMPLEADO,
            NUMERO_CUENTA_EMPLEADO: this.state.NUMERO_CUENTA_EMPLEADO,
            INICIO_PERIODO: this.state.fecha_inicial,
            FIN_PERIODO: this.state.fecha_final,
            TOTAL_DIAS_NOMINA: this.state.TOTAL_TIEMPO_DEVENGADO,
            FECHA_DOCUMENTO: this.state.fecha_hoy,
            DEVENGADOS_TOTAL: totales.DEVENGADOS_TOTAL,
            DEDUCCIONES_TOTAL: totales.DEDUCCIONES_TOTAL,
            COMPROBANTE_TOTAL: totales.COMPROBANTE_TOTAL,
            ID_TRANSACCION: "",
            DOCUMENTO_ENVIADO: 0,
            DOCUMENTO_ENVIADO_OBSERVACION: "",
            DOCUMENTO_RELACION: this.state.DOCUMENTO_RELACION,
            AJUSTE: this.state.AJUSTE

        }


        const doc_nomina = {
            cabecera,
            detalle
        }
        const datasend = {
            method: 'POST',
            body: JSON.stringify(doc_nomina),
            headers: {
                'Content-Type': 'application/json',
                'empresa': this.state.ID_EMPRESA,
                'tipo': this.state.tipo,
            }
        };
        fetch(config.servBackEnd + '/payroll/create', datasend).then(response => response.json())
            .then(data => {
                if(data.ok){ 
                    const m = `El documento ${data.NUMERO_DOCUMENTO_NOMINA} ha sido creado satisfactoriamente.`
                    this.setState({ showAlert: true, variant:'success',  alertmessage : m  });
                }else{
                    this.setState({ showAlert: true, variant:'danger ', alertmessage : data.message });
                }
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            });

        //setTimeout(window.location.reload(),4000);
    }

    diferenciadias = (tipo, name) => {
        const parametros = this.state.parametros[0]
        const id_inicial = tipo + "_fecha_inicial";
        const id_final = tipo + "_fecha_final";
        var fecha1 = moment(document.getElementById(id_inicial).value);
        var fecha2 = moment(document.getElementById(id_final).value);
        const currentLastDate = new Date(fecha2);
        const lastDayofMonth = new Date(currentLastDate.getFullYear(), currentLastDate.getMonth() + 1, 0);

        let adicional = 1;
        if(currentLastDate.getDate() ===31)adicional = 0;
        if(currentLastDate.getMonth()===1 && currentLastDate.getDate() === lastDayofMonth.getDate() )adicional = 30 - (lastDayofMonth.getDate() -1) ;

        const diff = fecha2.diff(fecha1, 'days') + adicional;
        this.setState({ 
            [name]: diff ,
            VALOR_PENSION: (this.state.SUELDO_EMPLEADO/30) * diff * (parametros.PORCENTAJE_PENSION/100),
            VALOR_SALUD: (this.state.SUELDO_EMPLEADO /30 )* diff * (parametros.PORCENTAJE_SALUD/100) ,
        });
    }

    changeForm = ({ target }) => {
        const name = target.name;
        const value = target.value
        this.setState({ [name]: value })
    }

    calcDevengados=( total_lin_exd, total_lin_exn, total_lin_recnoc, total_lin_domfes, total_lin_recdomfes, total_lin_nocdomfes, total_lin_renodomfes, total_vacaciones, total_prima, total_incapacidad_1, total_incapacidad_2, total_incapacidad_3, total_mapat, total_remu )=>{
        const limite = this.state.VALOR_SMLV * 2;
        const cesantias =parseFloat(this.state.TOTAL_CESANTIAS || 0) ;
        const int_cesantias =parseFloat(this.state.TOTAL_INT_CESANTIAS || 0) ;
        let validAuxTrans = false;

        // console.log(this.state.USAR_NORMA_LEY_EMPLEADO)
        // console.log(this.state.AUXILIO_TRANSPORTE_EMPLEADO)
        // console.log(this.state.SUELDO_EMPLEADO)
        // console.log(limite)

        if(this.state.USAR_NORMA_LEY_EMPLEADO && this.state.SUELDO_EMPLEADO <= limite) validAuxTrans = true;
        if(!this.state.USAR_NORMA_LEY_EMPLEADO && this.state.AUXILIO_TRANSPORTE_EMPLEADO) validAuxTrans = true;
        if(!this.state.USAR_NORMA_LEY_EMPLEADO && !this.state.AUXILIO_TRANSPORTE_EMPLEADO) validAuxTrans = false;

        // console.log(validAuxTrans)
        let auxilio_tra = 0;
        if( validAuxTrans) auxilio_tra = this.state.AUX_TRANSPORTE /30 * this.state.TOTAL_TIEMPO_DEVENGADO;
        const sueldo = (parseFloat(this.state.SUELDO_EMPLEADO) || 0 ) /30 * this.state.TOTAL_TIEMPO_DEVENGADO;
        const value = (auxilio_tra + cesantias + int_cesantias + parseFloat(total_lin_exd) + parseFloat(total_lin_exn) + parseFloat(total_lin_recnoc) + parseFloat(total_lin_domfes) + parseFloat(total_lin_recdomfes) + parseFloat(total_lin_nocdomfes) + parseFloat(total_lin_renodomfes) + parseFloat(total_vacaciones) + parseFloat(total_prima) + parseFloat(total_incapacidad_1) + parseFloat(total_incapacidad_2) + parseFloat(total_incapacidad_3) + parseFloat(total_mapat) + parseFloat(total_remu) + parseFloat(this.state.VALOR_OTRO_DEVENGADO) + sueldo  || 0 )
        return value
    }

    calcDeducciones=()=>{
        const value =  parseFloat(this.state.LIBRANZA) 
            + parseFloat(this.state.ANTICIPO) 
            + parseFloat(this.state.OTRAS_DEDUCCIONES)  
            + (parseFloat(this.state.VALOR_SALUD) || 0) 
            + (parseFloat(this.state.VALOR_PENSION) || 0);
        return value
    }

    render() {
        const mensajeConfirm = '¿Esta seguro que desea crear el documento de nómina?';
        const validacionUser = (this.state.tipo === '0' || this.state.tipo === '1');
        const rutaBack = '/home';
        const { empleados } = this.state;
        const { documentos } = this.state;
        const documento_empleado = this.state.DOCUMENTO_EMPLEADO;
        const porcentajesHorasExtras = {
            "TOTAL_HRED": 1.25,
            "TOTAL_HREN": 1.75,
            "HORAS_REC_NOC": 1.35,
            "HORAS_DOMIN_FEST": 2,
            "HORAS_REC_DOMIN_FEST": 1.75,
            "HORAS_NOC_DOMIN_FEST": 2.5,
            "HORAS_REC_NOC_DOMIN_FEST": 2.1
        }
        const diferenciadias = this.diferenciadias;
        //    Valores y totales de horas extras 
        const valor_hora_exd = ((this.state.VALOR_HORA) * porcentajesHorasExtras['TOTAL_HRED']).toFixed(2);
        const valor_hora_exn = ((this.state.VALOR_HORA) * porcentajesHorasExtras['TOTAL_HREN']).toFixed(2);
        const valor_rec_noc = ((this.state.VALOR_HORA) * porcentajesHorasExtras['HORAS_REC_NOC']).toFixed(2);
        const valor_domfes = ((this.state.VALOR_HORA) * porcentajesHorasExtras['HORAS_DOMIN_FEST']).toFixed(2);
        const valor_recdomfes = ((this.state.VALOR_HORA) * porcentajesHorasExtras['HORAS_REC_DOMIN_FEST']).toFixed(2);
        const valor_nocdomfes = ((this.state.VALOR_HORA) * porcentajesHorasExtras['HORAS_NOC_DOMIN_FEST']).toFixed(2);
        const valor_renodomfes = ((this.state.VALOR_HORA) * porcentajesHorasExtras['HORAS_REC_NOC_DOMIN_FEST']).toFixed(2);
        const total_lin_exd = (((this.state.VALOR_HORA) * porcentajesHorasExtras['TOTAL_HRED']) * this.state.TOTAL_HRED).toFixed(2);
        const total_lin_exn = (((this.state.VALOR_HORA) * porcentajesHorasExtras['TOTAL_HREN']) * this.state.TOTAL_HREN).toFixed(2);
        const total_lin_recnoc = (((this.state.VALOR_HORA) * porcentajesHorasExtras['HORAS_REC_NOC']) * this.state.HORAS_REC_NOC).toFixed(2);
        const total_lin_domfes = (((this.state.VALOR_HORA) * porcentajesHorasExtras['HORAS_DOMIN_FEST']) * this.state.HORAS_DOMIN_FEST).toFixed(2);
        const total_lin_recdomfes = (((this.state.VALOR_HORA) * porcentajesHorasExtras['HORAS_REC_DOMIN_FEST']) * this.state.HORAS_REC_DOMIN_FEST).toFixed(2);
        const total_lin_nocdomfes = (((this.state.VALOR_HORA) * porcentajesHorasExtras['HORAS_NOC_DOMIN_FEST']) * this.state.HORAS_NOC_DOMIN_FEST).toFixed(2);
        const total_lin_renodomfes = (((this.state.VALOR_HORA) * porcentajesHorasExtras['HORAS_REC_NOC_DOMIN_FEST']) * this.state.HORAS_REC_NOC_DOMIN_FEST).toFixed(2);
        // Valor y total de vacaciones
        //const valor_vacaciones = ((this.state.SUELDO_EMPLEADO * this.state.TOTAL_TIEMPO_DEVENGADO_V) / 720).toFixed(2);


        const total_vacaciones = this.state.TOTAL_LINEA_DEVENGADO_V ;
        // Valor y total de prima
        
        const total_prima = this.state.TOTAL_PRIMA;
        // Valor y total de incapacidad
        const valor_incapacidad_1 = (this.state.TIPO_INCAPACIDAD === "1") ? ((this.state.SUELDO_EMPLEADO / 30) * 2).toFixed(2) : 0;
        const total_incapacidad_1 = (this.state.TIPO_INCAPACIDAD === "1") ? (((this.state.SUELDO_EMPLEADO / 30) * 2) * this.state.TOTAL_TIEMPO_DEVENGADO_I).toFixed(2) : 0;
        const valor_incapacidad_2 = (this.state.TIPO_INCAPACIDAD === "2") ? ((this.state.SUELDO_EMPLEADO / 30) * 5).toFixed(2) : 0;
        const total_incapacidad_2 = (this.state.TIPO_INCAPACIDAD === "2") ? (((this.state.SUELDO_EMPLEADO / 30) * 5) * this.state.TOTAL_TIEMPO_DEVENGADO_I).toFixed(2) : 0;
        const valor_incapacidad_3 = (this.state.TIPO_INCAPACIDAD === "3") ? ((this.state.SUELDO_EMPLEADO / 30) * 7).toFixed(2) : 0;
        const total_incapacidad_3 = (this.state.TIPO_INCAPACIDAD === "3") ? (((this.state.SUELDO_EMPLEADO / 30) * 7) * this.state.TOTAL_TIEMPO_DEVENGADO_I).toFixed(2) : 0;
        // Valor y total de licencias
        const valor_mapat = (this.state.SUELDO_EMPLEADO / 30).toFixed(2);
        const total_mapat = (this.state.TOTAL_TIEMPO_DEVENGADO_L * (this.state.SUELDO_EMPLEADO / 30)).toFixed(2);
        const valor_remu = (this.state.SUELDO_EMPLEADO / 30).toFixed(2);
        const total_remu = (this.state.TOTAL_TIEMPO_DEVENGADO_L2 * (this.state.SUELDO_EMPLEADO / 30)).toFixed(2);
        // TOTALES
        const total_devengados = this.calcDevengados(total_lin_exd, total_lin_exn, total_lin_recnoc, total_lin_domfes, total_lin_recdomfes, total_lin_nocdomfes, total_lin_renodomfes, total_vacaciones, total_prima, total_incapacidad_1, total_incapacidad_2, total_incapacidad_3, total_mapat, total_remu)
        const total_deducciones = this.calcDeducciones()
        const total_documento = ((total_devengados || 0) - (total_deducciones || 0));
        const { showAlert, variant, alertmessage } = this.state;
        return (
            <div className="FormularioEmpresa">
                <Menu></Menu>
                <div>
                    <ModalConfirm show={this.state.show} enviarInfo={this.enviarInfo} handleClose={this.handleClose} mensaje={mensajeConfirm} ></ModalConfirm>
                </div>
                <Jumbotron className="Jumbotron">
                    <h2>NÓMINA EMPLEADOS</h2>
                </Jumbotron>
                {showAlert &&
                    <Alert variant={variant}>{alertmessage}</Alert>
                }
                {!validacionUser && <p>Usuario no valido para este modulo</p>}
                {validacionUser &&
                    <div>
                        <OverlayTrigger placement='top-start' overlay={<Tooltip>Atras</Tooltip>}>
                            <div className="div-back">
                                <a href={rutaBack}>
                                    <img src={back} className="icon" alt="" />
                                </a>
                            </div>
                        </OverlayTrigger>
                        <Form className="form" onSubmit={this.handleSubmit}>
                            <Card className="card">
                                <Card.Header>
                                    <Nav variant="tabs" defaultActiveKey="#first">

                                        <Nav.Item>
                                            <Nav.Link href="#disabled" disabled>
                                                <h5>PERIODO A PAGAR</h5>
                                            </Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                </Card.Header>
                                <Card.Body>
                                    <Form.Row>
                                        <Form.Group as={Col}>
                                            <Form.Label>FECHA INICIO</Form.Label>
                                            <Form.Control name="fecha_inicial" type="date" defaultValue={funciones.formatDate(this.state.fecha_inicial)} onChange={(e) => { diferenciadias("periodo", "TOTAL_TIEMPO_DEVENGADO"); this.setState({ fecha_inicial: e.target.value }) }} id="periodo_fecha_inicial" required />
                                        </Form.Group>
                                        <Form.Group as={Col}>
                                            <Form.Label>FECHA FIN</Form.Label>
                                            <Form.Control name="fecha_final" type="date" defaultValue={funciones.formatDate(this.state.fecha_final)} onChange={(e) => { diferenciadias("periodo", "TOTAL_TIEMPO_DEVENGADO"); this.setState({ fecha_final: e.target.value }) }} id="periodo_fecha_final" required />
                                        </Form.Group>

                                        <Form.Group>
                                            <Form.Label>TOTAL DIAS TRABAJADOS</Form.Label>
                                            <Form.Control name="TOTAL_TIEMPO_DEVENGADO" type="number" onChange={e => this.setState({ TOTAL_TIEMPO_DEVENGADO: e.target.value })} value={this.state.TOTAL_TIEMPO_DEVENGADO} required disabled />
                                        </Form.Group>
                                    </Form.Row>
                                </Card.Body>
                            </Card>

                            <Card>
                                <Card.Header>
                                    <Nav variant="tabs" defaultActiveKey="#first">

                                        <Nav.Item>
                                            <Nav.Link href="#disabled" disabled>
                                                <h5>EMPLEADO</h5>
                                            </Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                </Card.Header>

                                <Card.Body>
                                    <div>
                                        <Form.Row>
                                            <Form.Group as={Col}>
                                                <Form.Label>EMPLEADO</Form.Label>
                                                <SearchEmployee data={empleados} event={this.selectEmployee} style={{ width: 450 }} required></SearchEmployee>
                                            </Form.Group>

                                            <Form.Group as={Col}>
                                                <Form.Label>DOCUMENTO</Form.Label>
                                                <Form.Control name="DOCUMENTO_EMPLEADO" type="text" placeholder="Documento" defaultValue={this.state.DOCUMENTO_EMPLEADO} disabled ></Form.Control>
                                            </Form.Group>
                                        </Form.Row>
                                    </div>
                                </Card.Body>
                            </Card>
                            <Card>
                                <Card.Header>
                                    <Nav variant="tabs" defaultActiveKey="#first">

                                        <Nav.Item>
                                            <Nav.Link href="#disabled" disabled>
                                                <h5>AJUSTE DE NOMINA</h5>
                                            </Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                </Card.Header>
                                <Card.Body>
                                    <Form.Row>
                                        <Form.Group as={Col}>
                                            <Form.Label>CONFIRMAR SI ES UN AJUSTE</Form.Label>
                                            <br />
                                            <br />
                                            <input type="Checkbox" onChange={(e) => this.setState({ AJUSTE: e.target.checked })} ></input>
                                        </Form.Group>
                                        <Form.Group as={Col}>
                                            <Form.Label>DOCUMENTO A RELACIONAR</Form.Label>
                                            <Form.Control as="select" custom="true" onChange={(e) => this.setState({ DOCUMENTO_RELACION: e.target.value })} value={this.state.DOCUMENTO_RELACION}>
                                                <option key='d' value="">--Seleccione Documento --</option>
                                                {documentos.map(function (current, index) {
                                                    if (current.DOCUMENTO_EMPLEADO === documento_empleado) {
                                                        return <option key={'d' + index} value={current.TIPO_DOCUMENTO_NOMINA + current.NUMERO_DOCUMENTO_NOMINA} >{current.TIPO_DOCUMENTO_NOMINA + "-" + current.NUMERO_DOCUMENTO_NOMINA}</option>;
                                                    } else {
                                                        return null;
                                                    }

                                                })}
                                            </Form.Control>
                                        </Form.Group>
                                    </Form.Row>
                                </Card.Body>
                            </Card>

                            <Card>
                                <Card.Header>
                                    <Nav variant="tabs" defaultActiveKey="#first">

                                        <Nav.Item>
                                            <Nav.Link href="#disabled" disabled>
                                                <h5>INFORMACIÓN DEVENGADOS</h5>
                                            </Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                </Card.Header>
                                <Card.Body>
                                    {this.state.SALARIO_INTEGRAL.toString() === '0' &&
                                        <div>
                                            <Form.Row>
                                                <Form.Group as={Col}>
                                                    <Form.Label>HORAS EXTRAS</Form.Label>
                                                    <br />
                                                    <br />
                                                    <input type="Checkbox" onChange={(e) => this.setState({ horaExtr: e.target.checked })}></input>
                                                </Form.Group>
                                                {this.state.horaExtr && <div>
                                                    <Table>
                                                        <thead>
                                                            <tr>
                                                                <td style={{ width: 500 }}>TIPO</td>
                                                                <td style={{ width: 500 }}>VALOR</td>
                                                                <td style={{ width: 500 }}>CANTIDAD</td>
                                                                <td style={{ width: 500 }}>TOTAL LINEA</td>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td>DIURNAS</td>
                                                                <td className="currSign" style={{ textAlign: 'center' }}>{Intl.NumberFormat('es-MX').format(valor_hora_exd)}</td>
                                                                <td><Form.Control type="text" placeholder="Ingrese la cantidad" name="TOTAL_HRED" value={this.state.TOTAL_HRED} onChange={(e) => this.changeForm(e)}></Form.Control></td>
                                                                <td className="currSign" style={{ textAlign: 'center' }}>{Intl.NumberFormat('es-MX').format(total_lin_exd)}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>NOCTURNAS</td>
                                                                <td className="currSign" style={{ textAlign: 'center' }}>{Intl.NumberFormat('es-MX').format(valor_hora_exn)}</td>
                                                                <td> <Form.Control name="TOTAL_HREN" type="text" placeholder="Ingrese la cantidad" value={this.state.TOTAL_HREN} onChange={(e) => this.changeForm(e)}></Form.Control></td>
                                                                <td className="currSign" style={{ textAlign: 'center' }}>{Intl.NumberFormat('es-MX').format(total_lin_exn)}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>RECARGO NOCTURNO</td>
                                                                <td className="currSign" style={{ textAlign: 'center' }}>{Intl.NumberFormat('es-MX').format(valor_rec_noc)}</td>
                                                                <td><Form.Control name="HORAS_REC_NOC" value={this.state.HORAS_REC_NOC} onChange={(e) => this.changeForm(e)} type="text" placeholder="Ingrese la cantidad"></Form.Control></td>
                                                                <td className="currSign" style={{ textAlign: 'center' }}>{Intl.NumberFormat('es-MX').format(total_lin_recnoc)}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>DOMINICALES Y FESTIVAS</td>
                                                                <td className="currSign" style={{ textAlign: 'center' }}>{Intl.NumberFormat('es-MX').format(valor_domfes)}</td>
                                                                <td><Form.Control name="HORAS_DOMIN_FEST" value={this.state.HORAS_DOMIN_FEST} onChange={(e) => this.changeForm(e)} type="text" placeholder="Ingrese la cantidad"></Form.Control></td>
                                                                <td className="currSign" style={{ textAlign: 'center' }}>{Intl.NumberFormat('es-MX').format(total_lin_domfes)}</td>
                                                            </tr>
                                                            <tr>
                                                                <td> RECARGO DOMINICALES Y FESTIVAS</td>
                                                                <td className="currSign" style={{ textAlign: 'center' }}>{Intl.NumberFormat('es-MX').format(valor_recdomfes)}</td>
                                                                <td><Form.Control name="HORAS_REC_DOMIN_FEST" value={this.state.HORAS_REC_DOMIN_FEST} type="text" placeholder="Ingrese la cantidad" onChange={(e) => this.changeForm(e)}></Form.Control></td>
                                                                <td className="currSign" style={{ textAlign: 'center' }}>{Intl.NumberFormat('es-MX').format(total_lin_recdomfes)}</td>
                                                            </tr>
                                                            <tr>
                                                                <td> NOCTURNAS DOMINICALES Y FESTIVAS</td>
                                                                <td className="currSign" style={{ textAlign: 'center' }}>{Intl.NumberFormat('es-MX').format(valor_nocdomfes)}</td>
                                                                <td><Form.Control name="HORAS_NOC_DOMIN_FEST" value={this.state.HORAS_NOC_DOMIN_FEST} type="text" placeholder="Ingrese la cantidad" onChange={(e) => this.changeForm(e)} ></Form.Control></td>
                                                                <td className="currSign" style={{ textAlign: 'center' }}>{Intl.NumberFormat('es-MX').format(total_lin_nocdomfes)}</td>
                                                            </tr>
                                                            <tr>
                                                                <td> RECARGO NOCTURNO DOMINICALES Y FESTIVAS</td>
                                                                <td className="currSign" style={{ textAlign: 'center' }}>{Intl.NumberFormat('es-MX').format(valor_renodomfes)}</td>
                                                                <td><Form.Control name="HORAS_REC_NOC_DOMIN_FEST" value={this.state.HORAS_REC_NOC_DOMIN_FEST} type="text" placeholder="Ingrese la cantidad" onChange={(e) => this.changeForm(e)} ></Form.Control></td>
                                                                <td className="currSign" style={{ textAlign: 'center' }}>{Intl.NumberFormat('es-MX').format(total_lin_renodomfes)}</td>
                                                            </tr>
                                                        </tbody>
                                                    </Table>
                                                </div>}
                                            </Form.Row>
                                            <hr />
                                            <Form.Row>
                                                <Form.Group as={Col}>
                                                    <Form.Label>VACACIONES</Form.Label>
                                                    <br />
                                                    <br />
                                                    <input type="Checkbox" onChange={(e) => this.setState({ vacaciones: e.target.checked })} ></input>
                                                </Form.Group>
                                                {this.state.vacaciones && <div>
                                                    <Form.Row>
                                                        <Table>
                                                            <thead>
                                                                <tr>
                                                                    <td style={{ width: 500 }}>TIPO</td>
                                                                    <td style={{ width: 500 }}>FECHA INICIO</td>
                                                                    <td style={{ width: 500 }}>FECHA FIN</td>
                                                                    <td style={{ width: 500 }}>TOTAL DIAS</td>
                                                                    <td style={{ width: 500 }}>VALOR</td>
                                                                    <td style={{ width: 500 }}>TOTAL LINEA</td>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>VACACIONES</td>
                                                                    <td><Form.Control type="date" onChange={(e) => { this.setState({ fecha_inicial_v: e.target.value }) }} value={funciones.formatDate(this.state.fecha_inicial_v)} id="vacaciones_fecha_inicial" /></td>
                                                                    <td><Form.Control type="date" onChange={(e) => { this.setState({ fecha_final_v: e.target.value }) }} defaultValue={funciones.formatDate(this.state.fecha_final_v)} id="vacaciones_fecha_final" /></td>
                                                                    <td><Form.Control name="TOTAL_TIEMPO_DEVENGADO_V" type="text" placeholder="Dias" onChange={(e) => { this.setState({ TOTAL_TIEMPO_DEVENGADO_V: e.target.value }) }} value={this.state.TOTAL_TIEMPO_DEVENGADO_V}></Form.Control></td>
                                                                    <td><Form.Control name="TOTAL_LINEA_DEVENGADO_V" type="text" placeholder="Valor" onChange={(e) => { this.setState({ TOTAL_LINEA_DEVENGADO_V: e.target.value }) }} value={this.state.TOTAL_LINEA_DEVENGADO_V}></Form.Control></td>
                                                                    <td className="currSign" style={{ textAlign: 'center' }}>{Intl.NumberFormat('es-MX').format(total_vacaciones)}</td>
                                                                </tr>
                                                            </tbody>
                                                        </Table>
                                                    </Form.Row>
                                                </div>}
                                            </Form.Row>
                                            <hr />
                                            <Form.Row>
                                                <Form.Group as={Col}>
                                                    <Form.Label>CESANTIAS</Form.Label>
                                                    <br />
                                                    <br />
                                                    <input type="Checkbox" onChange={(e) => this.setState({ show_cesantias: e.target.checked })} ></input>
                                                </Form.Group>
                                                {this.state.show_cesantias && <div>
                                                    <Form.Row>
                                                        <Table>
                                                            <thead>
                                                                <tr>
                                                                    <td style={{ width: 500 }}>TIPO</td>
                                                                    <td style={{ width: 500 }}>TOTAL CESANTIAS</td>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>CESANTIAS</td>
                                                                    <td><Form.Control name="TOTAL_CESANTIAS" type="text" placeholder="Valor a pagar" value={this.state.TOTAL_CESANTIAS} onChange={(e) => this.setState({ TOTAL_CESANTIAS: e.target.value })} ></Form.Control></td>
                                                                </tr>
                                                            </tbody>
                                                        </Table>
                                                    </Form.Row>
                                                </div>}
                                            </Form.Row>
                                            <hr />
                                            <Form.Row>
                                                <Form.Group as={Col}>
                                                    <Form.Label>INT. CESANTIAS</Form.Label>
                                                    <br />
                                                    <br />
                                                    <input type="Checkbox" onChange={(e) => this.setState({ show_int_cesantias: e.target.checked })} ></input>
                                                </Form.Group>
                                                {this.state.show_int_cesantias  && <div>
                                                    <Form.Row>
                                                        <Table>
                                                            <thead>
                                                                <tr>
                                                                    <td style={{ width: 500 }}>TIPO</td>
                                                                    <td style={{ width: 500 }}>TOTAL INT PRIMA</td>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>INT CESANTIAS</td>
                                                                    <td><Form.Control name="TOTAL_INT_CESANTIAS" type="text" placeholder="Valor a pagar" value={this.state.TOTAL_INT_CESANTIAS} onChange={(e) => this.setState({ TOTAL_INT_CESANTIAS: e.target.value })} ></Form.Control></td>
                                                                </tr>
                                                            </tbody>
                                                        </Table>
                                                    </Form.Row>
                                                </div>}
                                            </Form.Row>
                                            <hr />
                                            <Form.Row>
                                                <Form.Group as={Col}>
                                                    <Form.Label>PRIMA</Form.Label>
                                                    <br />
                                                    <br />
                                                    <input type="Checkbox" onChange={(e) => this.setState({ prima: e.target.checked })} ></input>
                                                </Form.Group>
                                                {this.state.prima && <div>
                                                    <Form.Row>
                                                        <Table>
                                                            <thead>
                                                                <tr>
                                                                    <td style={{ width: 500 }}>TIPO</td>
                                                                    <td style={{ width: 500 }}>TOTAL PRIMA</td>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>PRIMA</td>
                                                                    <td><Form.Control name="TOTAL_PRIMA" type="text" placeholder="Valor a pagar" value={this.state.TOTAL_PRIMA} onChange={(e) => this.setState({ TOTAL_PRIMA: e.target.value })} ></Form.Control></td>
                                                                </tr>
                                                            </tbody>
                                                        </Table>
                                                    </Form.Row>
                                                </div>}
                                            </Form.Row>
                                            <hr />
                                            <Form.Row>
                                                <Form.Group as={Col}>
                                                    <Form.Label>INCAPACIDADES</Form.Label>
                                                    <br />
                                                    <br />
                                                    <input type="Checkbox" onChange={(e) => this.setState({ incap: e.target.checked })} ></input>
                                                </Form.Group>
                                                {this.state.incap && <div>
                                                    <Form.Row>
                                                        <Table>
                                                            <thead>
                                                                <tr>
                                                                    <td style={{ width: 500 }}>TIPO</td>
                                                                    <td style={{ width: 500 }}>FECHA INICIO</td>
                                                                    <td style={{ width: 500 }}>FECHA FIN</td>
                                                                    <td style={{ width: 500 }}>TOTAL DIAS</td>
                                                                    <td style={{ width: 500 }}>TIPO</td>
                                                                    <td style={{ width: 500 }}>VALOR</td>
                                                                    <td style={{ width: 500 }}>TOTAL LINEA</td>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>INCAPACIDAD</td>
                                                                    <td><Form.Control type="date" onChange={(e) => { diferenciadias("incapacidad", "TOTAL_TIEMPO_DEVENGADO_I"); this.setState({ fecha_inicial_I: e.target.value }) }} value={funciones.formatDate(this.state.fecha_inicial_I)} id="incapacidad_fecha_inicial" /></td>
                                                                    <td><Form.Control type="date" onChange={(e) => { diferenciadias("incapacidad", "TOTAL_TIEMPO_DEVENGADO_I"); this.setState({ fecha_final_I: e.target.value }) }} defaultValue={funciones.formatDate(this.state.fecha_final_I)} id="incapacidad_fecha_final" /></td>
                                                                    <td><Form.Control name="TOTAL_TIEMPO_DEVENGADO_I" type="text" placeholder="Dias" defaultValue={this.state.TOTAL_TIEMPO_DEVENGADO_I} disabled></Form.Control></td>
                                                                    <td><Form.Control as="select" onChange={e => this.setState({ TIPO_INCAPACIDAD: e.target.value })} value={this.state.TIPO_INCAPACIDAD} required >
                                                                        <option value="">Seleccione</option>
                                                                        <option value="1">COMUN</option>
                                                                        <option value="2">PROFESIONAL</option>
                                                                        <option value="3">LABORAL</option>
                                                                    </Form.Control></td>
                                                                    {this.state.TIPO_INCAPACIDAD === "1" &&
                                                                        <Fragment>
                                                                            <td className="currSign" style={{ textAlign: 'center' }}>{Intl.NumberFormat('es-MX').format(valor_incapacidad_1)}</td>
                                                                            <td className="currSign" style={{ textAlign: 'center' }}>{Intl.NumberFormat('es-MX').format(total_incapacidad_1)}</td>
                                                                        </Fragment>
                                                                    }
                                                                    {this.state.TIPO_INCAPACIDAD === "2" &&
                                                                        <Fragment>
                                                                            <td className="currSign" style={{ textAlign: 'center' }}>{Intl.NumberFormat('es-MX').format(valor_incapacidad_2)}</td>
                                                                            <td className="currSign" style={{ textAlign: 'center' }}>{Intl.NumberFormat('es-MX').format(total_incapacidad_2)}</td>
                                                                        </Fragment>
                                                                    }
                                                                    {this.state.TIPO_INCAPACIDAD === "3" &&
                                                                        <Fragment>
                                                                            <td className="currSign" style={{ textAlign: 'center' }}>{Intl.NumberFormat('es-MX').format(valor_incapacidad_3)}</td>
                                                                            <td className="currSign" style={{ textAlign: 'center' }}>{Intl.NumberFormat('es-MX').format(total_incapacidad_3)}</td>
                                                                        </Fragment>
                                                                    }

                                                                </tr>
                                                            </tbody>
                                                        </Table>
                                                    </Form.Row>
                                                </div>}
                                            </Form.Row>
                                            <hr />
                                            <Form.Row>
                                                <Form.Group as={Col}>
                                                    <Form.Label>LICENCIAS</Form.Label>
                                                    <br />
                                                    <br />
                                                    <input type="Checkbox" onChange={(e) => this.setState({ licen: e.target.checked })} ></input>
                                                </Form.Group>
                                                {this.state.licen && <div>
                                                    <Form.Row>

                                                        <Table>
                                                            <thead>
                                                                <tr>
                                                                    <td style={{ width: 500 }}>TIPO</td>
                                                                    <td style={{ width: 500 }}>FECHA INICIO</td>
                                                                    <td style={{ width: 500 }}>FECHA FIN</td>
                                                                    <td style={{ width: 500 }}>TOTAL DIAS</td>
                                                                    <td style={{ width: 500 }}>VALOR</td>
                                                                    <td style={{ width: 500 }}>TOTAL LINEA</td>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>MATERNIDAD/PATERNIDAD</td>
                                                                    <td><Form.Control type="date" onChange={(e) => { diferenciadias("licenciamp", "TOTAL_TIEMPO_DEVENGADO_L"); this.setState({ fecha_inicial_l: e.target.value }) }} value={funciones.formatDate(this.state.fecha_inicial_l)} id="licenciamp_fecha_inicial" /></td>
                                                                    <td><Form.Control type="date" onChange={(e) => { diferenciadias("licenciamp", "TOTAL_TIEMPO_DEVENGADO_L"); this.setState({ fecha_final_l: e.target.value }) }} defaultValue={funciones.formatDate(this.state.fecha_final_l)} id="licenciamp_fecha_final" /></td>
                                                                    <td><Form.Control name="TOTAL_TIEMPO_DEVENGADO_L" type="text" placeholder="Dias" defaultValue={this.state.TOTAL_TIEMPO_DEVENGADO_L} disabled></Form.Control></td>
                                                                    <td className="currSign" style={{ textAlign: 'center' }}>{Intl.NumberFormat('es-MX').format(valor_mapat)}</td>
                                                                    <td className="currSign" style={{ textAlign: 'center' }}>{Intl.NumberFormat('es-MX').format(total_mapat)}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>REMUNERADA</td>
                                                                    <td><Form.Control type="date" onChange={(e) => { diferenciadias("licenciar", "TOTAL_TIEMPO_DEVENGADO_L2"); this.setState({ fecha_inicial_l2: e.target.value }) }} value={funciones.formatDate(this.state.fecha_inicial_l2)} id="licenciar_fecha_inicial" /></td>
                                                                    <td><Form.Control type="date" onChange={(e) => { diferenciadias("licenciar", "TOTAL_TIEMPO_DEVENGADO_L2"); this.setState({ fecha_final_l2: e.target.value }) }} defaultValue={funciones.formatDate(this.state.fecha_final_l2)} id="licenciar_fecha_final" /></td>
                                                                    <td><Form.Control name="TOTAL_TIEMPO_DEVENGADO_L2" type="text" placeholder="Dias" defaultValue={this.state.TOTAL_TIEMPO_DEVENGADO_L2} disabled></Form.Control></td>
                                                                    <td className="currSign" style={{ textAlign: 'center' }}>{Intl.NumberFormat('es-MX').format(valor_remu)}</td>
                                                                    <td className="currSign" style={{ textAlign: 'center' }}>{Intl.NumberFormat('es-MX').format(total_remu)}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>NO REMUNERADA</td>
                                                                    <td><Form.Control type="date" onChange={(e) => { diferenciadias("licencianr", "TOTAL_TIEMPO_DEVENGADO_L3"); this.setState({ fecha_inicial_l3: e.target.value }) }} value={funciones.formatDate(this.state.fecha_inicial_l3)} id="licencianr_fecha_inicial" /></td>
                                                                    <td><Form.Control type="date" onChange={(e) => { diferenciadias("licencianr", "TOTAL_TIEMPO_DEVENGADO_L3"); this.setState({ fecha_final_l3: e.target.value }) }} defaultValue={funciones.formatDate(this.state.fecha_final_l3)} id="licencianr_fecha_final" /></td>
                                                                    <td><Form.Control name="TOTAL_TIEMPO_DEVENGADO_L3" type="text" placeholder="Dias" defaultValue={this.state.TOTAL_TIEMPO_DEVENGADO_L3} disabled></Form.Control></td>
                                                                </tr>
                                                            </tbody>
                                                        </Table>
                                                    </Form.Row>
                                                </div>}
                                            </Form.Row>
                                            <hr />
                                            <Form.Row>
                                                <Form.Group as={Col}>
                                                    <Form.Label>OTROS DEVENGADOS</Form.Label>
                                                    <br />
                                                    <br />
                                                    <input type="Checkbox" onChange={(e) => this.setState({ otros: e.target.checked })} ></input>
                                                </Form.Group>
                                                {this.state.otros && <div>
                                                    <Form.Row>
                                                        <Table>
                                                            <thead>
                                                                <tr>
                                                                    <td style={{ width: 500 }}>TIPO</td>
                                                                    <td style={{ width: 500 }}>DESCRIPCION</td>
                                                                    <td style={{ width: 500 }}>VALOR</td>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>OTRO DEVENGADO</td>
                                                                    <td><Form.Control type="text" placeholder="Ingrese la descripcion" value={this.state.DES_OTRO_DEVEN} onChange={(e) => this.setState({ DES_OTRO_DEVEN: e.target.value })}></Form.Control></td>
                                                                    <td><Form.Control name="VALOR_OTRO_DEVENGADO" type="text" placeholder="Ingrese la cantidad" value={this.state.VALOR_OTRO_DEVENGADO} onChange={(e) => this.setState({ VALOR_OTRO_DEVENGADO: e.target.value })}></Form.Control></td>
                                                                </tr>
                                                            </tbody>
                                                        </Table>
                                                    </Form.Row>
                                                </div>}
                                            </Form.Row>
                                        </div>
                                    }
                                    {this.state.SALARIO_INTEGRAL === 1 &&
                                        <div>
                                            <Form.Row>
                                                <Form.Group as={Col}>
                                                    <Form.Label>VACACIONES</Form.Label>
                                                    <br />
                                                    <br />
                                                    <input type="Checkbox" onChange={(e) => this.setState({ vacaciones: e.target.checked })} ></input>
                                                </Form.Group>
                                            </Form.Row>
                                        </div>
                                    }
                                </Card.Body>
                            </Card>

                            <Card>
                                <Card.Header>
                                    <Nav variant="tabs" defaultActiveKey="#first">

                                        <Nav.Item>
                                            <Nav.Link href="#disabled" disabled>
                                                <h5>INFORMACIÓN DEDUCCIONES</h5>
                                            </Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                </Card.Header>
                                <Card.Body>
                                    <Form.Row>
                                        <Form.Group as={Col}>
                                            <Form.Label>LIBRANZAS</Form.Label>
                                            <br />
                                            <br />
                                            <input type="Checkbox" onChange={(e) => this.setState({ libra: e.target.checked })} ></input>
                                        </Form.Group>
                                        {this.state.libra && <div>
                                            <Table>
                                                <thead>
                                                    <tr>
                                                        <td style={{ width: 500 }}>TIPO</td>
                                                        <td style={{ width: 500 }}>DESCRIPCION</td>
                                                        <td style={{ width: 500 }}>VALOR</td>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>LIBRANZAS</td>
                                                        <td><Form.Control name="" type="text" placeholder="Descripcion" value={this.state.DESCRIPCION_LIBRANZA} onChange={(e) => this.setState({ DESCRIPCION_LIBRANZA: e.target.value })}></Form.Control></td>
                                                        <td><Form.Control type="text" placeholder="Ingrese el valor" value={this.state.LIBRANZA} onChange={(e) => this.setState({ LIBRANZA: e.target.value })}></Form.Control></td>
                                                        <td></td>
                                                    </tr>
                                                </tbody>
                                            </Table>
                                        </div>}
                                    </Form.Row>
                                    <hr />
                                    {/* <Form.Row>
                                        <Form.Group as={Col}>
                                            <Form.Label>PAGO TERCEROS</Form.Label>
                                            <br />
                                            <br />
                                            <input type="Checkbox" onChange={(e) => this.setState({ pagter: e.target.checked })} ></input>
                                        </Form.Group>
                                        {this.state.pagter && <div>
                                            <Form.Row>
                                                <Form.Group as={Col}>
                                                    <Form.Label>VALOR</Form.Label>
                                                    <Form.Control type="text" placeholder="Ingrese el valor" style={{ width: 500 }}></Form.Control>
                                                </Form.Group>
                                            </Form.Row>
                                        </div>}
                                    </Form.Row>
                                    <hr /> */}

                                    <Form.Row>
                                        <Form.Group as={Col}>
                                            <Form.Label>ANTICIPOS</Form.Label>
                                            <br />
                                            <br />
                                            <input type="Checkbox" onChange={(e) => this.setState({ anti: e.target.checked })} ></input>
                                        </Form.Group>
                                        {this.state.anti && <div>
                                            <Table>
                                                <thead>
                                                    <tr>
                                                        <td style={{ width: 500 }}>TIPO</td>
                                                        <td style={{ width: 500 }}>VALOR</td>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>ANTICIPOS</td>
                                                        <td><Form.Control name="ANTICIPO" type="text" placeholder="Ingrese el valor" value={this.state.ANTICIPO} onChange={(e) => this.setState({ ANTICIPO: e.target.value })}></Form.Control></td>
                                                    </tr>
                                                </tbody>
                                            </Table>
                                        </div>}
                                    </Form.Row>

                                    <hr />
                                    <Form.Row>
                                        <Form.Group as={Col}>
                                            <Form.Label>OTRAS DEDUCCIONES</Form.Label>
                                            <br />
                                            <br />
                                            <input type="Checkbox" onChange={(e) => this.setState({ otrade: e.target.checked })} ></input>
                                        </Form.Group>
                                        {this.state.otrade && <div>
                                            <Table>
                                                <thead>
                                                    <tr>
                                                        <td style={{ width: 500 }}>TIPO</td>
                                                        <td style={{ width: 500 }}>DESCRIPCION</td>
                                                        <td style={{ width: 500 }}>VALOR</td>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>OTRAS DEDUCCIONES</td>
                                                        <td><Form.Control type="text" placeholder="Ingrese la descripcion" value={this.state.DES_OTRA_DEDUC} onChange={(e) => this.setState({ DES_OTRA_DEDUC: e.target.value })}></Form.Control></td>
                                                        <td><Form.Control name="OTRAS_DEDUCCIONES" type="text" placeholder="Ingrese el valor" value={this.state.OTRAS_DEDUCCIONES} onChange={(e) => this.setState({ OTRAS_DEDUCCIONES: e.target.value })}></Form.Control></td>
                                                    </tr>
                                                </tbody>
                                            </Table>
                                        </div>}
                                    </Form.Row>


                                </Card.Body>
                            </Card>

                            <Card className="card">
                                <Card.Header>
                                    <Nav variant="tabs" defaultActiveKey="#first">

                                        <Nav.Item>
                                            <Nav.Link href="#disabled" disabled>
                                                <h5>TOTALES</h5>
                                            </Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                </Card.Header>
                                <Card.Body>
                                    <Table>
                                        <thead>
                                            <tr>
                                                <td style={{ width: 500 }}>TOTAL DEVENGADOS</td>
                                                <td style={{ width: 500 }}>TOTAL DEDUCCIONES</td>
                                                <td style={{ width: 500 }}>TOTAL DEL DOCUMENTO</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td className="currSign" style={{ textAlign: 'center' }}>{Intl.NumberFormat('es-MX').format(total_devengados)}</td>
                                                <td className="currSign" style={{ textAlign: 'center' }}>{Intl.NumberFormat('es-MX').format(total_deducciones)}</td>
                                                <td className="currSign" style={{ textAlign: 'center' }}>{Intl.NumberFormat('es-MX').format(total_documento)}</td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </Card.Body>
                            </Card>

                            <Button variant="primary" type="submit">Guardar</Button>
                        </Form>

                    </div>
                }
                <Mensajes estado={this.state.mostrarMensaje} mensaje={this.state.mensaje} ocultar={() => this.setState({ mostrarMensaje: false })} ></Mensajes>
            </div>
        );
    }
}
export default (FormularioParametros);
//<-- disabled={!this.validateForm()} -->